import Vue from 'vue';
import Vuex from 'vuex';
import HeatmapService from '../../services/HeatmapService';

Vue.use(Vuex);

export default {
    state: {
        showLegend: false,
        showChart: false,
        showHeatmapChart: false,
        startDate: '',
        endDate: '',
        transactionTotal: 0,
        dateCounts: null,
    },
    mutations: {
        TOGGLE_LEGEND(state: any, show: boolean) {
            state.showLegend = !state.showLegend;
        },
        TOGGLE_CHART(state: any) {
            state.showChart = !state.showChart;
        },
        TOGGLE_HEATMAP_CHART(state: any) {
            state.showHeatmapChart = !state.showHeatmapChart;
        },
        SET_END_DATE(state: any, endDate: string) {
            state.endDate = endDate;
        },
        SET_START_DATE(state: any, startDate: string) {
            state.startDate = startDate;
        },
        SET_TRANSACTION_TOTAL(state: any, total: number) {
            state.transactionTotal = total;
        },
        SET_DATE_COUNTS(state: any, data: any) {
            state.dateCounts = data;
        },
    },
    actions: {
        updateHeatmap(context: any, payload: any) {
            // UNUSED CSVLayer directly consumes api data
            console.log('updateHeatmap aciton');
            console.log(payload);
            HeatmapService.getLockboxData(payload.startDate, payload.endDate)
            .then((response) => {
                console.log(response);
            });
        },
        updateDateCount(context: any, payload: any) {
            console.log(' update date counts ');
            let transactionTotal = 0;
            HeatmapService.getDateCount(payload.startDate, payload.endDate)
            .then((response) => {
                console.log(response);
                context.commit('SET_DATE_COUNTS', response.data);
                for (const data of response.data) {
                    transactionTotal += data.count;
                }
                context.commit('SET_TRANSACTION_TOTAL', transactionTotal);
                console.log(transactionTotal);
            })
            .catch((error) => {
                console.error(error);
                context.dispatch('notify', 'Bad request, please adjust date range');
            });
        },
        toggleLegend(context: any) {
            context.commit('TOGGLE_LEGEND');
        },
        toggleChart(context: any) {
            context.commit('TOGGLE_CHART');
        },
        toggleHeatmapChart(context: any) {
            context.commit('TOGGLE_HEATMAP_CHART');
        },
        updateEndDate(context: any, payload: string) {
            context.commit('SET_END_DATE', payload);
        },
        updateStartDate(context: any, payload: string) {
            context.commit('SET_START_DATE', payload);
        },
        initHeatmap(context: any) {
            // no state/mutations, this is only used to subscribe to actions in other components
        },
    },
};
